import { ReactElement } from "react";
import { gql, useMutation, MutationFunction } from "@apollo/client";
import {
  OtpValidateEmailResponse,
  MutationOtpValidateEmailArgs
} from "../../../../schemaTypes";

// GraphQL mutation matching the resolver
export const otpValidateEmailMutation = gql`
  mutation OtpValidateEmailMutation(
    $verificationCode: String!
    $email: String!
  ) {
    otpValidateEmail(
      verificationCode: $verificationCode
      email: $email
    ) {
      errors {
        path
        message
      }
      message
    }
  }
`;

export interface OtpEmailValidateProps {
  otpEmailValidate: MutationFunction<
    OtpValidateEmailResponse,
    MutationOtpValidateEmailArgs
  >;
  loading: boolean;
  error?: Error;
  data?: OtpValidateEmailResponse;
}

interface Props {
  children: (data: OtpEmailValidateProps) => ReactElement | null;
}

export const OtpValidateEmail: React.FC<Props> = ({ children }) => {
  const [otpEmailValidate, { loading, error, data }] = useMutation<
    OtpValidateEmailResponse,
    MutationOtpValidateEmailArgs
  >(otpValidateEmailMutation);

  // Pass mutation function and states to children
  return children({ otpEmailValidate, loading, error, data: data ?? undefined });
};